import React from 'react';

import { Text } from '@reckon-web/text';

import { ActivityTargetValue } from '../activities-types';
import { getTargetType } from '../helper';

interface IActivityCategoryClosed {
  activityTarget: ActivityTargetValue;
}
// ActivityCategory Closed = 13
export const ActivityCategoryClosed = ({
  activityTarget,
}: IActivityCategoryClosed) => (
  <Text size="small">Closed this {getTargetType(activityTarget)}</Text>
);
